import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VideoViewer from './VideoViewer';
import AudioViewer from './AudioViewer';
import ImageViewer from './ImageViewer';

const MediaViewer = () => {
    const navigate = useNavigate();
    const [mediaType, setMediaType] = useState(null);
    const [mediaId, setMediaId] = useState(null);

    useEffect(() => {
        // Get media type and ID from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        const id = urlParams.get('id');
        
        if (type && id) {
            setMediaType(type);
            setMediaId(id);
        } else {
            // Redirect back if no valid parameters
            navigate('/', { replace: true });
        }
    }, [navigate]);

    if (!mediaType || !mediaId) {
        return (
            <div className="min-h-screen bg-gray-900 flex items-center justify-center">
                <div className="text-white text-lg">Loading...</div>
            </div>
        );
    }

    // Render the appropriate viewer based on media type
    switch (mediaType) {
        case 'video':
            return <VideoViewer uploadId={mediaId} />;
        case 'audio':
            return <AudioViewer uploadId={mediaId} />;
        case 'image':
            return <ImageViewer uploadId={mediaId} />;
        default:
            return (
                <div className="min-h-screen bg-gray-900 flex items-center justify-center">
                    <div className="text-center">
                        <div className="text-red-400 text-lg mb-4">Invalid media type</div>
                        <button 
                            onClick={() => navigate('/')}
                            className="text-purple-400 hover:text-purple-300"
                        >
                            Go back to home
                        </button>
                    </div>
                </div>
            );
    }
};

export default MediaViewer;